import { useLocation, useNavigate } from "react-router-dom";
import Text from "../styleguide/Text";
import Colors from "../theme/Colors";
import { getFirstLetterUpperCase } from "../utils/parsers";
import { initialMainRoute } from "./routesConstants";
import BreadcrumbBackButton, { isMainPagePath } from "./BreadcrumbBackButton";

function BreadcrumbsComponent() {
  const location = useLocation();
  const navigate = useNavigate();

  if (isMainPagePath(location.pathname)) return null;

  const currentPathArray = location.pathname.split("/").slice(1);

  const filteredDisplayPath = currentPathArray
    .map((segment, index) => ({ segment, index }))
    .filter(({ segment }) => isNaN(Number(segment)));

  if (!currentPathArray.includes(initialMainRoute)) {
    filteredDisplayPath.unshift({ segment: initialMainRoute, index: -1 });
  }

  if (filteredDisplayPath.length === 0) return null;

  return (
    <div className="flex min-h-[64px] items-center gap-3 bg-white px-7 py-2">
      <BreadcrumbBackButton />
      <div className="flex min-w-0 flex-1 flex-wrap items-center">
        {filteredDisplayPath.map(({ segment }, idx) => {
          const isDashboard = segment === initialMainRoute;
          const isLast = idx === filteredDisplayPath.length - 1;
          const steps = filteredDisplayPath.length - 1 - idx;

          return (
            <span key={segment} className="flex items-center">
              {isLast ? (
                <Text color={Colors.black}>
                  {getFirstLetterUpperCase(segment)}
                </Text>
              ) : (
                <span
                  className="cursor-pointer text-muted transition-colors hover:text-[#2196f3]"
                  onClick={
                    isDashboard ? () => navigate("/") : () => navigate(-steps)
                  }>
                  {getFirstLetterUpperCase(segment)}
                </span>
              )}
              {!isLast && <span className="mx-2 text-muted">/</span>}
            </span>
          );
        })}
      </div>
    </div>
  );
}

export default BreadcrumbsComponent;
